(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-Page"] && !Shopify.designMode) return;
  try {
    
(function () {
function mountHalloweenPage(root) {
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const controller = new AbortController();
  let revealObserver;
  const timers = new Set();
  const later = (callback, delay) => {
    const id = window.setTimeout(() => { timers.delete(id); callback(); }, delay);
    timers.add(id);
    return id;
  };
  root.tqHalloweenCleanup = () => {
    controller.abort();
    if (revealObserver) revealObserver.disconnect();
    timers.forEach(id => window.clearTimeout(id));
    delete root.dataset.ready;
    const hero = root.querySelector('[data-hero-gate]');
    if (hero) hero.classList.remove('tqhw-is-opening', 'tqhw-is-restoring', 'tqhw-is-open');
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* TV promo → automatically open Pumpkin Quest */
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-quest]');

    if (!trigger || !root.contains(trigger)) return;

    event.preventDefault();

    const quest = root.querySelector('tq-halloween-quest');

    if (!quest) return;

    if (
      typeof quest.openQuest === 'function' &&
      quest.panel &&
      quest.start
    ) {
      quest.openQuest();
      return;
    }

    const startButton = quest.querySelector('[data-quest-start]');

    if (startButton) {
      startButton.click();
    }
  }, { signal: controller.signal });

  // Standard reveal animations for the sections below the hero.
  const items = root.querySelectorAll('[data-reveal]');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    revealObserver = io;
    items.forEach(el => io.observe(el));
  } else {
    items.forEach(el => el.classList.add('is-visible'));
  }

  // Single-gate hero text animation.
  // Down at the hero: one gesture hides the content.
  // After that, scrolling is completely normal.
  // When the visitor scrolls back to the hero start, one extra upward gesture restores the content.
  const hero = root.querySelector('[data-hero-gate]');

  if (!hero || reduceMotion) return;

  let heroState = 'closed';
  let touchStartY = 0;
  let touchConsumed = false;

  const animationDuration =
    window.matchMedia('(max-width: 749px)').matches
      ? 850
      : 1350;

  const atHeroGate = () => {
    const rect = hero.getBoundingClientRect();
    const upperLimit = Math.max(160, window.innerHeight * 0.18);

    return rect.top >= -8 && rect.top <= upperLimit;
  };

  const openHero = () => {
    if (heroState !== 'closed') return;

    heroState = 'opening';
    hero.classList.remove('tqhw-is-restoring', 'tqhw-is-open');
    hero.classList.add('tqhw-is-opening');

    later(() => {
      hero.classList.remove('tqhw-is-opening');
      hero.classList.add('tqhw-is-open');
      heroState = 'open';
    }, animationDuration);
  };

  const restoreHero = () => {
    if (heroState !== 'open') return;

    heroState = 'restoring';
    hero.classList.remove('tqhw-is-open', 'tqhw-is-opening');
    hero.classList.add('tqhw-is-restoring');

    later(() => {
      hero.classList.remove('tqhw-is-restoring');
      heroState = 'closed';
    }, animationDuration);
  };

  const handleWheel = (event) => {
    if (event.target instanceof Element && event.target.closest('tq-halloween-quest, button, a, input, select, textarea, [contenteditable="true"]')) return;
    const delta = event.deltaY;

    if (Math.abs(delta) < 8) return;

    // Keep the banner still only while its text animation is running.
    if (heroState === 'opening' || heroState === 'restoring') {
      if (atHeroGate()) event.preventDefault();
      return;
    }

    // First downward gesture at the banner: hide the content.
    if (
      delta > 0 &&
      heroState === 'closed' &&
      atHeroGate()
    ) {
      event.preventDefault();
      openHero();
      return;
    }

    // Important: while open, downward scrolling is NEVER blocked.
    // The page behaves like a normal banner immediately after the animation.

    // Coming back up: scroll normally until the banner itself is reached.
    // Only the next upward gesture restores the content.
    if (
      delta < 0 &&
      heroState === 'open' &&
      atHeroGate()
    ) {
      event.preventDefault();
      restoreHero();
    }
  };

  const handleTouchStart = (event) => {
    if (event.target instanceof Element && event.target.closest('tq-halloween-quest, button, a, input, select, textarea, [contenteditable="true"]')) return;
    if (!event.touches.length) return;

    touchStartY = event.touches[0].clientY;
    touchConsumed = false;
  };

  const handleTouchMove = (event) => {
    if (event.target instanceof Element && event.target.closest('tq-halloween-quest, button, a, input, select, textarea, [contenteditable="true"]')) return;
    if (!event.touches.length) return;

    if (heroState === 'opening' || heroState === 'restoring') {
      if (atHeroGate()) event.preventDefault();
      return;
    }

    if (touchConsumed) return;

    const currentY = event.touches[0].clientY;
    const distance = touchStartY - currentY;

    if (Math.abs(distance) < 24) return;

    // Finger moves up = page would scroll down.
    if (
      distance > 0 &&
      heroState === 'closed' &&
      atHeroGate()
    ) {
      event.preventDefault();
      touchConsumed = true;
      openHero();
      return;
    }

    // Finger moves down = page would scroll up.
    // Restore only after normal scrolling has brought the banner back to its gate position.
    if (
      distance < 0 &&
      heroState === 'open' &&
      atHeroGate()
    ) {
      event.preventDefault();
      touchConsumed = true;
      restoreHero();
    }
  };

  const handleTouchEnd = () => {
    touchConsumed = false;
  };

  const handleKeydown = (event) => {
    if (event.target instanceof Element && event.target.closest('tq-halloween-quest, button, a, input, select, textarea, [contenteditable="true"]')) return;
    const downKeys = ['ArrowDown', 'PageDown', ' ', 'Spacebar'];
    const upKeys = ['ArrowUp', 'PageUp'];

    if (heroState === 'opening' || heroState === 'restoring') {
      if ((downKeys.includes(event.key) || upKeys.includes(event.key)) && atHeroGate()) {
        event.preventDefault();
      }
      return;
    }

    if (
      downKeys.includes(event.key) &&
      heroState === 'closed' &&
      atHeroGate()
    ) {
      event.preventDefault();
      openHero();
      return;
    }

    if (
      upKeys.includes(event.key) &&
      heroState === 'open' &&
      atHeroGate()
    ) {
      event.preventDefault();
      restoreHero();
    }
  };

  window.addEventListener('wheel', handleWheel, {
    passive: false, signal: controller.signal
  });

  window.addEventListener('touchstart', handleTouchStart, {
    passive: true, signal: controller.signal
  });

  window.addEventListener('touchmove', handleTouchMove, {
    passive: false, signal: controller.signal
  });

  window.addEventListener('touchend', handleTouchEnd, {
    passive: true, signal: controller.signal
  });

  window.addEventListener('keydown', handleKeydown, { signal: controller.signal });
}

const findHalloweenPages = (scope) => {
  const pages = [...scope.querySelectorAll('[data-tq-halloween-page]')];
  if (scope.matches && scope.matches('[data-tq-halloween-page]')) pages.unshift(scope);
  return pages;
};
findHalloweenPages(document).forEach(mountHalloweenPage);
document.addEventListener('shopify:section:load', event => {
  findHalloweenPages(event.target).forEach(mountHalloweenPage);
});
document.addEventListener('shopify:section:unload', event => {
  findHalloweenPages(event.target).forEach(root => {
    if (root.tqHalloweenCleanup) root.tqHalloweenCleanup();
  });
});
// Rewards reference existing Shopify discounts. Shopify validates their rules.
// Theme code cannot securely restrict a shared coupon to a verified game score.
if (!customElements.get('tq-halloween-quest')) {
  customElements.define('tq-halloween-quest', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected && !this.controller) this.mountQuest();
      });
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      this.clearQuestTimers();
    }

    clearQuestTimers() {
      clearTimeout(this.hintTimer);
      clearTimeout(this.hintUnlockTimer);
      clearTimeout(this.hintCooldownTimer);
      clearTimeout(this.finalAlertTimer);
      clearInterval(this.clockTimer);
    }

    mountQuest() {
      this.start = this.querySelector('[data-quest-start]');
      this.panel = this.querySelector('[data-quest-panel]');
      if (!this.start || !this.panel) return;

      this.controller = new AbortController();
      this.pumpkins = [...this.querySelectorAll('[data-quest-pumpkin]')];
      this.secretPumpkin = this.pumpkins[this.pumpkins.length - 1];
      this.templates = [...this.querySelectorAll('[data-quest-reward-template]')]
        .sort((a, b) => Number(a.dataset.minScore) - Number(b.dataset.minScore));
      this.board = this.querySelector('[data-quest-board]');
      this.status = this.querySelector('[data-quest-status]');
      this.progress = this.querySelector('[data-quest-progress]');
      this.hint = this.querySelector('[data-quest-hint]');
      this.hintLabel = this.querySelector('[data-quest-hint-label]');
      this.finishButton = this.querySelector('[data-quest-finish]');
      this.clock = this.querySelector('[data-quest-clock]');
      this.victory = this.querySelector('[data-quest-victory]');
      this.rewards = this.querySelector('[data-quest-rewards]');
      this.finalAlert = this.querySelector('[data-quest-final-alert]');
      this.startLabel = this.querySelector('[data-quest-start-label]');
      this.originalLabel = this.originalLabel || this.startLabel.textContent;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.designMode = this.dataset.designMode === 'true';
      this.duration = Math.max(0, Number(this.dataset.duration) || 0);
      this.hintUnlockSeconds = Math.max(0, Number(this.dataset.hintUnlock) || 15);
      this.hintPenaltySeconds = Math.max(0, Number(this.dataset.hintPenalty) || 5);
      this.storageKey = 'tq-score-quest-v2:' + this.dataset.sectionId + ':' +
        this.templates.map(el => el.dataset.minScore + '=' + el.dataset.rewardCode).join('|');

      this.found = new Set();
      this.bestScore = 0;
      this.state = 'idle';
      this.remaining = this.duration * 1000;
      this.deadline = 0;
      this.hintReady = false;
      this.hintCoolingDown = false;

      try {
        const saved = Number(sessionStorage.getItem(this.storageKey));
        if (!this.designMode && Number.isInteger(saved) && saved > 0 && saved <= 10) {
          this.bestScore = saved;
          this.state = 'finished';
          this.pumpkins.slice(0, saved).forEach(p => this.found.add(p.dataset.questPumpkin));
          this.placePumpkins();
        }
      } catch (_) { /* Storage is optional; gameplay still works without it. */ }

      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-quest-start]')) this.openQuest();
        if (button.matches('[data-quest-close]')) this.closeQuest();
        if (button.matches('[data-quest-pumpkin]')) this.findPumpkin(button, event.detail === 0);
        if (button.matches('[data-quest-hint]')) this.showHint();
        if (button.matches('[data-quest-finish]')) this.finishQuest();
        if (button.matches('[data-quest-replay]')) this.replayQuest();
        if (button.matches('[data-quest-copy]')) this.copyCode(button);
      }, { signal: this.controller.signal });

      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          event.preventDefault();
          this.closeQuest();
        }
      }, { signal: this.controller.signal });

      this.start.hidden = false;
      this.updateQuest();
      if (this.state === 'finished') this.renderReward();
    }

    scrollTo(element) {
      element.scrollIntoView({ block: 'start', behavior: this.reducedMotion ? 'auto' : 'smooth' });
    }

    openQuest() {
      this.panel.hidden = false;
      this.start.setAttribute('aria-expanded', 'true');

      if (this.state === 'idle') {
        this.state = 'playing';
        this.remaining = this.duration * 1000;
        this.placePumpkins();
        this.startHintUnlock();
        this.startClock();
      } else if (this.state === 'playing') {
        this.startClock();
      }

      const finished = this.state === 'finished';
      this.querySelector(finished ? '[data-quest-victory-heading]' : '[data-quest-game-heading]')
        .focus({ preventScroll: true });
      this.scrollTo(finished ? this.victory : this.panel);
      this.updateQuest();
    }

    closeQuest() {
      this.panel.hidden = true;
      this.start.setAttribute('aria-expanded', 'false');
      this.start.focus({ preventScroll: true });
      this.start.scrollIntoView({ block: 'nearest', behavior: 'auto' });
      // The countdown deliberately keeps running so closing the panel cannot pause the challenge.
    }

     desktopLayouts() {
      return [[
        { x: 8.5,  y: 57.0, d: 'easy',   r: -7 },
        { x: 22.5, y: 39.0, d: 'medium', r: 6 },
        { x: 38.0, y: 68.0, d: 'hard',   r: -5 },
        { x: 48.0, y: 27.0, d: 'medium', r: 5 },
        { x: 61.0, y: 74.0, d: 'easy',   r: -6 },
        { x: 67.5, y: 46.0, d: 'hard',   r: 4 },
        { x: 78.8, y: 47.5, d: 'medium', r: -4 },
        { x: 90.5, y: 32.5, d: 'easy',   r: 7 },
        { x: 95.0, y: 68.0, d: 'medium', r: -6 }
      ]];
    }

    mobileLayouts() {
      return [[
        { x: 13.0, y: 39.0, d: 'easy',   r: -6 },
        { x: 50.5, y: 24.5, d: 'medium', r: 5 },
        { x: 82.0, y: 35.5, d: 'hard',   r: -5 },
        { x: 31.5, y: 50.5, d: 'medium', r: 6 },
        { x: 21.0, y: 70.0, d: 'hard',   r: -7 },
        { x: 56.5, y: 64.0, d: 'easy',   r: 4 },
        { x: 74.0, y: 74.0, d: 'medium', r: -4 },
        { x: 47.0, y: 86.0, d: 'easy',   r: 5 },
        { x: 11.5, y: 84.0, d: 'medium', r: -6 }
      ]];
    }

    secretSlots(isMobile) {
      return isMobile
        ? [
            { x: 35.0, y: 22.0, d: 'secret', r: -5 }
          ]
        : [
            { x: 54.0, y: 14.5, d: 'secret', r: -5 }
          ];
    }

    applySlot(pumpkin, slot) {
      pumpkin.classList.remove(
        'is-easy', 'is-medium', 'is-hard', 'is-secret',
        'is-partial-left', 'is-partial-right', 'is-partial-bottom', 'is-partial-top',
        'is-wanderer', 'is-revealed', 'is-hinted'
      );
      pumpkin.style.setProperty('--pumpkin-x', slot.x + '%');
      pumpkin.style.setProperty('--pumpkin-y', slot.y + '%');
      pumpkin.style.setProperty('--pumpkin-rotate', (slot.r || 0) + 'deg');
      pumpkin.classList.add('is-' + (slot.d || 'easy'));
      if (slot.p) pumpkin.classList.add('is-partial-' + slot.p);
      if (slot.move) pumpkin.classList.add('is-wanderer');
    }

    placePumpkins() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const layouts = isMobile ? this.mobileLayouts() : this.desktopLayouts();

      /* Always use the first layout so positions never move between games. */
      const layout = layouts[0];

      this.pumpkins.slice(0, 9).forEach((pumpkin, index) => {
        this.applySlot(pumpkin, layout[index]);
        pumpkin.hidden = false;
      });

      /* Always use one fixed position for the final pumpkin too. */
      const secretChoices = this.secretSlots(isMobile);
      const secretSlot = secretChoices[0];

      this.applySlot(this.secretPumpkin, secretSlot);
      this.secretPumpkin.classList.add('is-secret');
      this.secretPumpkin.hidden = !(this.found.has(this.secretPumpkin.dataset.questPumpkin) || this.found.size >= 9);
    }

    startHintUnlock() {
      clearTimeout(this.hintUnlockTimer);
      clearTimeout(this.hintCooldownTimer);
      this.hintCoolingDown = false;
      this.hintReady = this.hintUnlockSeconds === 0;
      this.updateHintButton();
      if (this.hintReady || this.state !== 'playing') return;

      this.hintUnlockTimer = setTimeout(() => {
        if (!this.isConnected || this.state !== 'playing') return;
        this.hintReady = true;
        this.updateHintButton();
      }, this.hintUnlockSeconds * 1000);
    }

    updateHintButton() {
      if (!this.hint || !this.hintLabel) return;
      const finished = this.state === 'finished';
      this.hint.hidden = finished;
      if (finished) return;
      this.hint.disabled = !this.hintReady;

      if (this.hintReady) {
        this.hintLabel.textContent = this.hintPenaltySeconds > 0
          ? this.dataset.tHintPenalty.replace('__SECONDS__', this.hintPenaltySeconds)
          : this.dataset.tGiveHint;
      } else if (this.hintCoolingDown) {
        this.hintLabel.textContent = this.dataset.tHintRecharging;
      } else {
        this.hintLabel.textContent = this.dataset.tHintUnlocks.replace('__SECONDS__', this.hintUnlockSeconds);
      }
    }

    startClock() {
      clearInterval(this.clockTimer);
      if (!this.duration || this.state !== 'playing') return;
      this.deadline = Date.now() + this.remaining;

      const tick = () => {
        if (this.state !== 'playing') return;
        this.remaining = Math.max(0, this.deadline - Date.now());
        this.updateClock();
        if (!this.remaining) this.finishQuest();
      };

      tick();
      this.clockTimer = setInterval(tick, 180);
    }

    updateClock() {
      if (!this.clock) return;
      const seconds = Math.ceil(this.remaining / 1000);
      this.clock.textContent = seconds + 's';
      this.clock.setAttribute('aria-label', seconds + ' seconds remaining');
      this.clock.classList.toggle('is-low', seconds <= 10);
    }

    unlockSecret() {
      if (!this.secretPumpkin || !this.secretPumpkin.hidden || this.state !== 'playing') return;
      this.secretPumpkin.hidden = false;
      this.secretPumpkin.disabled = false;
      this.secretPumpkin.classList.add('is-revealed');
      this.secretPumpkin.setAttribute('aria-label', 'Find the final enchanted pumpkin');

      if (this.finalAlert) {
        this.finalAlert.hidden = false;
        clearTimeout(this.finalAlertTimer);
        this.finalAlertTimer = setTimeout(() => {
          if (this.finalAlert) this.finalAlert.hidden = true;
        }, 2600);
      }
    }

    findPumpkin(pumpkin, keyboard) {
      if (
        this.state !== 'playing' ||
        this.panel.hidden ||
        pumpkin.hidden ||
        this.found.has(pumpkin.dataset.questPumpkin)
      ) return;

      this.found.add(pumpkin.dataset.questPumpkin);
      if (this.found.size === 9) this.unlockSecret();
      this.updateQuest();

      if (this.found.size === this.pumpkins.length) {
        this.finishQuest();
      } else if (keyboard) {
        const next = this.pumpkins.find(p => !p.disabled && !p.hidden);
        if (next) next.focus({ preventScroll: true });
      }
    }

    updateQuest() {
      const count = this.found.size;
      const finished = this.state === 'finished';
      const message = count === 10
        ? this.dataset.tWholeVillageGlowing
        : count === 9
          ? this.dataset.tOneLightRemains
          : count >= 7
            ? this.dataset.tVillageBrightening
            : count > 0
              ? this.dataset.tLittleLightReturns
              : this.dataset.tEveryLightCounts;

      this.status.textContent = this.dataset.tPumpkinsFound
        .replace('__COUNT__', count)
        .replace('__MESSAGE__', message);

      this.progress.value = count;
      this.progress.textContent = this.dataset.tProgressCount.replace('__COUNT__', count);

      const lightLevel = Math.min(.98, .46 + count * .052);
      const mistLevel = Math.max(.04, .60 - count * .055);

      this.board.style.setProperty('--quest-light', String(lightLevel));
      this.board.style.setProperty('--quest-mist-opacity', String(mistLevel));
      this.board.classList.toggle('is-saved', count === 10);

      this.pumpkins.forEach(pumpkin => {
        const found = this.found.has(pumpkin.dataset.questPumpkin);
        const isSecret = pumpkin === this.secretPumpkin;
        const lockedSecret = isSecret && !found && count < 9;
        if (isSecret) pumpkin.hidden = lockedSecret;
        pumpkin.disabled = found || finished || lockedSecret;
        pumpkin.classList.toggle('is-found', found);
        if (found) pumpkin.classList.remove('is-hinted');
        pumpkin.setAttribute('aria-pressed', String(found));
        pumpkin.setAttribute('aria-label', (found ? 'Found' : 'Find') + (isSecret ? ' final' : '') + ' enchanted pumpkin ' + pumpkin.dataset.questPumpkin);
      });

      this.finishButton.hidden = finished;
      this.victory.hidden = !finished;
      this.startLabel.textContent = finished
        ? (this.bestScore ? this.dataset.tViewReward : this.dataset.tViewResult)
        : this.state === 'playing'
          ? this.dataset.tContinueQuest
          : this.originalLabel;

      this.updateHintButton();
      this.updateClock();
    }

    finishQuest() {
      if (this.state !== 'playing') return;
      clearInterval(this.clockTimer);
      clearTimeout(this.hintTimer);
      clearTimeout(this.hintUnlockTimer);
      clearTimeout(this.hintCooldownTimer);
      this.state = 'finished';
      this.bestScore = Math.max(this.bestScore, this.found.size);

      try {
        if (!this.designMode && this.bestScore) sessionStorage.setItem(this.storageKey, String(this.bestScore));
      } catch (_) { /* The reward remains available for the current page visit. */ }

      this.updateQuest();
      this.renderReward();
      if (!this.panel.hidden) {
        this.querySelector('[data-quest-victory-heading]').focus({ preventScroll: true });
        this.scrollTo(this.victory);
      }
    }

    renderReward() {
      const template = this.templates[0];
      const requiredScore = template ? Number(template.dataset.minScore) : 7;
      const unlocked = template && this.bestScore >= requiredScore;

      this.rewards.replaceChildren();

      if (unlocked) {
        this.rewards.append(template.content.cloneNode(true));
      }

      this.querySelector('[data-quest-result-terms]').hidden = !unlocked;

      if (unlocked) {
        this.querySelector('[data-quest-result-kicker]').textContent =
          this.bestScore === 10
            ? this.dataset.tCurseLifted
            : this.dataset.tLightReturned;

        this.querySelector('[data-quest-victory-heading]').textContent =
          this.dataset.tVillageBackToLife;

        this.querySelector('[data-quest-result-summary]').textContent =
          this.dataset.tSuccessSummary;
      } else {
        this.querySelector('[data-quest-result-kicker]').textContent =
          this.dataset.tVillageStillNeedsYou;

        this.querySelector('[data-quest-victory-heading]').textContent =
          this.dataset.tMoreLightNeeded;

        this.querySelector('[data-quest-result-summary]').textContent =
          this.dataset.tRewardNotUnlocked
            .replace('__SCORE__', this.bestScore)
            .replace('__REQUIRED__', requiredScore);
      }
    }

    showHint() {
      if (this.state !== 'playing' || !this.hintReady) return;

      const candidates = this.pumpkins.filter(p => !p.disabled && !p.hidden && !this.found.has(p.dataset.questPumpkin));
      if (!candidates.length) return;
      const pumpkin = candidates[Math.floor(Math.random() * candidates.length)];

      clearTimeout(this.hintTimer);
      this.pumpkins.forEach(p => p.classList.remove('is-hinted'));
      pumpkin.classList.add('is-hinted');

      if (this.duration && this.hintPenaltySeconds > 0) {
        this.remaining = Math.max(0, this.remaining - this.hintPenaltySeconds * 1000);
        this.deadline = Date.now() + this.remaining;
        this.updateClock();
        if (!this.remaining) {
          this.finishQuest();
          return;
        }
      }

      this.status.textContent = this.found.size + ' / 10 pumpkins found. A hidden pumpkin is glowing briefly' + (this.hintPenaltySeconds ? ' — ' + this.hintPenaltySeconds + ' seconds lost.' : '.');
      this.hintReady = false;
      this.hintCoolingDown = true;
      this.updateHintButton();

      this.hintTimer = setTimeout(() => pumpkin.classList.remove('is-hinted'), 2200);
      this.hintCooldownTimer = setTimeout(() => {
        if (!this.isConnected || this.state !== 'playing') return;
        this.hintCoolingDown = false;
        this.hintReady = true;
        this.updateHintButton();
      }, 8000);
    }

    replayQuest() {
      this.clearQuestTimers();
      this.found.clear();
      this.state = 'playing';
      this.remaining = this.duration * 1000;
      this.deadline = 0;
      this.hintReady = false;
      this.hintCoolingDown = false;
      if (this.finalAlert) this.finalAlert.hidden = true;
      this.placePumpkins();
      this.startHintUnlock();
      this.updateQuest();
      this.startClock();
      this.querySelector('[data-quest-game-heading]').focus({ preventScroll: true });
      this.scrollTo(this.panel);
    }

    async copyCode(button) {
      const reward = button.closest('[data-quest-reward]');
      const offer = button.closest('.tqhw__quest-offer');

      const codeElement = reward
        ? reward.querySelector('[data-quest-code]')
        : offer
          ? offer.querySelector('[data-offer-code]')
          : null;

      if (!codeElement) return;

      const code = codeElement.textContent.trim();

      const feedback = reward
        ? reward.querySelector('[data-quest-copy-status]')
        : null;

      const offerLabel = offer
        ? button.querySelector('[data-offer-copy-label]')
        : null;

      try {
        if (!navigator.clipboard || !navigator.clipboard.writeText) {
          throw new Error('Clipboard unavailable');
        }

        await navigator.clipboard.writeText(code);

        if (feedback && this.isConnected) {
          feedback.textContent = 'Code copied.';
        }

        if (offerLabel && this.isConnected) {
          offerLabel.textContent = 'Copied!';

          setTimeout(() => {
            if (this.isConnected) {
              offerLabel.textContent = 'Copy';
            }
          }, 1800);
        }
      } catch (_) {
        if (feedback && this.isConnected) {
          feedback.textContent = 'Select the code above to copy it.';
        }

        if (offerLabel && this.isConnected) {
          offerLabel.textContent = 'Try again';

          setTimeout(() => {
            if (this.isConnected) {
              offerLabel.textContent = 'Copy';
            }
          }, 1800);
        }
      }
    }
  });
}

})();

  } catch(e) { console.error(e); }
})();
})();
